import { useEffect, useState } from 'react';

export type SkeletonStatusProps = {
  /** Localized, specific loading text. Supply this once per region, never once per bar. */
  label: string;
  loading?: boolean;
};

/** Keep mounted beside the busy region, outside aria-busy, including while content is ready. */
export const SkeletonStatus = ({ label, loading = true }: SkeletonStatusProps) => {
  const [message, setMessage] = useState('');

  useEffect(() => {
    setMessage('');
    if (!loading) return;
    // Register the empty live region before changing its text, including on an initial loading mount.
    const timer = setTimeout(() => setMessage(label), 0);
    return () => clearTimeout(timer);
  }, [label, loading]);

  return (
    <span className="sr-only" role="status" aria-live="polite" aria-atomic="true">
      {loading ? message : ''}
    </span>
  );
};
